<!-- <div class="row">
	<div class="col-md-12 col-sm-12 col-12 ">
		<div class="alert-content justify-content-end">
			<div class="alert alert-danger alert-dismissible fade show" role="alert">
				<div class="h3 font-weight-bold text-uppercase">
					We're Hiring
				</div>
				<div class="lead text-capitalize">
					<div>
						<i class="fa fa-dot-circle-o" aria-hidden="true"></i>
						VB.NET
					</div>
					<div>
						<i class="fa fa-dot-circle-o" aria-hidden="true"></i>
						.NET
					</div>
					<div>
						<i class="fa fa-dot-circle-o" aria-hidden="true"></i>
						C#
					</div>
					<div class="text-uppercase">
						<i class="fa fa-dot-circle-o" aria-hidden="true"></i>
						Marketing
					</div>
				</div>
				<button type="button" class="close" data-dismiss="alert" aria-label="Close" title="close">
					<span class="text-danger" aria-hidden="true">
						<i class="fa fa-times-circle-o" aria-hidden="true"></i>
					</span>
				</button>
			</div> 
		</div>
	</div>
</div> -->


<div class=" d-none d-sm-block">
	<div class="header-gradient">
		<div class="slideshow-container">
			<div
			  class="slide"
			  *ngFor="let slide of slides; let i = index"
			  [class.active]="i === currentIndex"
			>
			  <img [src]="slide.image" alt="Slide Image" class="slide-image" />
			  <div class="caption">{{ slide.caption }}</div>
			</div>
		  </div>
		  
		<!-- <div class="card product-card ">
			 <div class="card-body d-none d-sm-block animatable bounceInLeft">
				<h1 class="text-light">
					        Annaa Silicon Technology Private Limited
					<sup style=" border-radius: 50%; padding: 0.3%;">
						<i class= "fa fa-registered" aria-hidden="true"></i>
					</sup>
				</h1>
				<h5 class="text-light font-italic company">
					Technology Makers Pleasure
				</h5>
			</div>
			<div class="card-body d-block d-sm-none animatable bounceInLeft">
				<h4 class="text-light">
					Annaa Silicon Technology Private Limited
					<sup style="border: 2px solid #fff; border-radius: 50%; padding: 0.3%;">
						<i class="fa fa-registered" aria-hidden="true"></i>
					</sup>
				</h4>
				<h6 class="text-light font-italic company">
					Technology Makes Pleasure
				</h6>
			</div>
			<br />
			<div class="d-none d-sm-block">
				<div class="row pb-3 animatable bounceIn">
					<div class="col-md-2 col-sm-12 col-xs-8 text-center">
						<img src="./../../assets/img/home/icon/work.png" class="rounded pb-2" style="width: 90%;"
							alt="ICON" />
						<h5 class="text-center text-light">Work Collaboration</h5>
					</div>
					<div class="col-md-2 col-sm-12 col-xs-12 text-center">
						<img src="./../../assets/img/home/icon/messages.png" class="rounded pb-2" style="width: 90%;"
							alt="ICON" />
						<h5 class="text-center text-light">Bulk SMS Gateway</h5>
					</div>
					<div class="col-md-2 col-sm-12 col-xs-12 text-center">
						<img src="./../../assets/img/home/icon/barcode.png" class="rounded pb-2"
							style="width: 90%;" alt="ICON" />
						<h5 class="text-center text-light">Barcode Solutions</h5>
					</div>
					<div class="col-md-2 col-sm-12 col-xs-12 text-center">
						<img src="./../../assets/img/home/icon/website.png" class="rounded pb-2" style="width: 90%;"
							alt="ICON" />
						<h5 class="text-center text-light">Web Application</h5>
					</div>
					<div class="col-md-2 col-sm-12 col-xs-12 text-center">
						<img src="./../../assets/img/home/icon/mobile.png" class="rounded pb-2"
							style="width: 90%;" alt="ICON" />
						<h5 class="text-center text-light">Mobile Applications</h5>
					</div>
					<div class="col-md-2 col-sm-12 col-xs-12 text-center">
						<img src="./../../assets/img/home/icon/pay.png" class="rounded pb-2" style="width: 90%;"
							alt="ICON" />
						<h5 class="text-center text-light">Payroll Management</h5>
					</div>
				</div>
			</div>
			<div class="row pb-3 w3-animate-left d-block d-sm-none">
				<div class="col-md-2 col-sm-12 col-xs-8 text-center">
					<img src="./../../assets/img/home/icon/work.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Work Collaboration</h5>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 text-center">
					<img src="./../../assets/img/home/icon/messages.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Bulk SMS Gateway</h5>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 text-center">
					<img src="./../../assets/img/home/icon/barcode.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Barcode Solutions</h5>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 text-center">
					<img src="./../../assets/img/home/icon/website.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Web Application</h5>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 text-center">
					<img src="./../../assets/img/home/icon/mobile.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Mobile Applications</h5>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 text-center">
					<img src="./../../assets/img/home/icon/payroll.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Payroll Management</h5>
				</div>
			</div>
		</div> -->
	</div>

	<!--	-------  Our Services	-------	 -->
	<!-- <span class="fa fa-cogs head-icon"></span> -->
	<div class="p-4">
		<div class="container-fluid">
			<div class="container row">
				<div class="border border-bottom-0 border-left-0 border-top-0 p-2 d-none d-sm-block">
					<span class="fa fa-cogs service-icon" aria-hidden="true"></span>
				</div>
				<h2 class="text-center text-dark mb-4 font-weight-bolder text-uppercase p-2 d-none d-sm-block">
					Our Services
				</h2>
				<h5 class="text-center text-dark mb-4 font-weight-bolder text-uppercase p-2 d-block d-sm-none">
					Our Services
				</h5>
			</div>
			<br />
			<div class="row">
				<div class="col-md-5 col-sm-12 col-xs-12  bounceIn">
					<div class="card service-card border-0 p-4 ">
						<div class="text-center">
							<span class="fa fa-gear service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								multi brand screw air compressor service
							</h6>
							<p class="text-justify text-muted" style="color: black;">
								Regular Inspections: Conduct routine checks to identify potential issues early..
							</p><br />
							<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/screw-air-compressor">
								Show More
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-5 col-sm-12 col-xs-12 bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-bolt service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								Multi brand piston compressor service
							</h6>
							<p class="text-justify text-muted">
								Expert maintenance and repair for all multi-brand piston compressors, ensuring optimal performance and reliability..
							</p><br>
							<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/piston-compressor">
								Show More
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12 animatable bounceInLeft">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-gear service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								Multi brand air dryer service
							</h6>
							<p class="text-justify text-muted">
								Comprehensive servicing and repairs for all multi-brand air dryers to maintain efficient, moisture-free air supply.
							</p><br>
							<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/air-dryer">
								Show More
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-industry service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								multi brand water chiller services 
							</h6>
							<p class="text-justify text-muted">
								Efficient servicing and repair solutions for all multi-brand water chillers, ensuring optimal cooling performance and energy savings.
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/water-chiller">
										Show More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceInRight">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-plug service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								multi brand oil chiller service  
							</h6>
							<p class="text-justify text-muted">
								Expert installation, maintenance, and repair of air pipelines to ensure efficient and safe air distribution across your facility.
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/oil-chiller">
										Show More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-fire-extinguisher service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								panel air cooler services
							</h6>
							<p class="text-justify text-muted">
					"Ensure optimal performance and longevity of your equipment with our expert panel air cooler services,
				 including installation, maintenance, and repairs for all major brands."
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/panel-air-cooler">
										Show More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-fire-extinguisher service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								air pipe line works
							</h6>
							<p class="text-justify text-muted">						
							"Delivering efficient and reliable air pipeline solutions, from design and 
							installation to maintenance and repairs, ensuring optimal airflow and system performance."
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/air-pipe-line">
										Show More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>


				<!--   -->
			</div>
		</div>
		<br />
	</div>




	<div class="p-4">
		<div class="container-fluid">
		  <!-- Hero Section -->
		  <div class="hero-section text-center py-5">
			<h1 class="display-4 text-dark font-weight-bold">Welcome to Our Products</h1>
			<p class="text-muted lead">
				Transform your operations with our high-performance products designed for efficiency and innovation.
			</p>
			<button class="btn btn-primary btn-lg mt-3" routerLink="/clients">
				View Our Gallery
			</button>
		  </div>
		  <hr class="my-4" />
	  
		  <!-- Feature Section -->
		  <div class="row text-center">
			<div class="col-md-4 col-sm-12 my-3">
			  <div class="card border-0 shadow-lg">
				<div class="card-body">
				  <span class="fa fa-lightbulb-o feature-icon text-primary"></span>
				  <h5 class="card-title font-weight-bold mt-3">SCREW AIR COMPRESSOR</h5>
				  <p class="card-text text-muted">
					Explore cutting-edge ideas that drive growth and efficiency.
				  </p>
				  <button class="btn btn-outline-primary mt-3" routerLink="/screw">
					Discover More
				  </button>
				</div>
			  </div>
			</div>
			<div class="col-md-4 col-sm-12 my-3">
			  <div class="card border-0 shadow-lg">
				<div class="card-body">
				  <span class="fa fa-cogs feature-icon text-success"></span>
				  <h5 class="card-title font-weight-bold mt-3">PISTON AIR COMPRESSOR</h5>
				  <p class="card-text text-muted">
					Benefit from our high-performance solutions tailored to you.
				  </p>
				  <button class="btn btn-outline-success mt-3" routerLink="/piston">
					Discover More
				  </button>
				</div>
			  </div>
			</div>
			<div class="col-md-4 col-sm-12 my-3">
			  <div class="card border-0 shadow-lg">
				<div class="card-body">
				  <span class="fa fa-user feature-icon text-danger"></span>
				  <h5 class="card-title font-weight-bold mt-3">AIR DRYER</h5>
				  <p class="card-text text-muted">
					Enjoy 24/7 customer support for a seamless experience.
				  </p>
				  <button class="btn btn-outline-danger mt-3" routerLink="/airdryer">
					Discover More
				  </button>
				</div>
			  </div>
			</div>
			<div class="col-md-4 col-sm-12 my-3">
				<div class="card border-0 shadow-lg">
				  <div class="card-body">
					<span class="fas fa-home"></span> 
					<h5 class="card-title font-weight-bold mt-3">AIR RECEIVER TANK</h5>
					<p class="card-text text-muted">
					  Enjoy 24/7 customer support for a seamless experience.
					</p>
					<button class="btn btn-outline-danger mt-3" routerLink="/airtank">
					  Discover More
					</button>
				  </div>
				</div>
			  </div>
			  <div class="col-md-4 col-sm-12 my-3">
				<div class="card border-0 shadow-lg">
				  <div class="card-body">
					<span class="fa fa-cloud"></span>
					<h5 class="card-title font-weight-bold mt-3">WATER CHILLER</h5>
					<p class="card-text text-muted">
					  Enjoy 24/7 customer support for a seamless experience.
					</p>
					<button class="btn btn-outline-danger mt-3" routerLink="/waterchiller">
					  Discover More
					</button>
				  </div>
				</div>
			  </div>
			  <div class="col-md-4 col-sm-12 my-3">
				<div class="card border-0 shadow-lg">
				  <div class="card-body">
					<span class="fa fa-lock"></span>
					<h5 class="card-title font-weight-bold mt-3">OIL CHILLER</h5>
					<p class="card-text text-muted">
					  Enjoy 24/7 customer support for a seamless experience.
					</p>
					<button class="btn btn-outline-danger mt-3" routerLink="/oilchiller">
					  Discover More
					</button>
				  </div>
				</div>
			  </div>
			  <div class="col-md-4 col-sm-12 my-3">
				<div class="card border-0 shadow-lg">
				  <div class="card-body">
					<span class="fa fa-bell"></span>
					<h5 class="card-title font-weight-bold mt-3">AIR ACCESSORIES</h5>
					<p class="card-text text-muted">
					  Enjoy 24/7 customer support for a seamless experience.
					</p>
					<button class="btn btn-outline-danger mt-3" routerLink="/airaccessories">
					  Discover More
					</button>
				  </div>
				</div>
			  </div>
		  </div>
	  
		  <!-- Call to Action Section -->
		  <div class="text-center my-5">
			<h2 class="font-weight-bold">Shape the Future of Your Business with Us</h2>
			<p class="text-muted lead">
			  Contact us today to learn how we can help you achieve your goals.
			</p>
			<button class="btn btn-primary btn-lg" routerLink="/contact-us">
			  Contact Us
			</button>
		  </div>
		</div>
	  </div>
	  

	<!--	------	 About US	----------	 -->
	<!-- <div class="row col  text-center">
		<div class="col-md-6 col-sm-12 col-xs-12  bounceInLeft"
			style="padding-left: 0px; padding-right: 0px; margin-left: 0px; margin-right: 0px;">
			<img src="./../../assets/img/home/rb_1592.png" style="width: 100%;" />
		</div>

		<div class="color col-md-6 col-sm-12 col-xs-12  bounceInRight">
			<div class="row text-right">
				<div class="border border-bottom-0 border-left-0 border-top-0 p-2  d-none d-sm-block">
					<span class="fa fa-user head-icon"></span>
				</div>
				<h2 class="text-center text-dark-blue mb-4 font-weight-bolder text-uppercase p-2 d-none d-sm-block">
					Little About Us
				</h2>
				<h5 class="text-center text-dark-blue font-weight-bolder text-uppercase p-2 d-block d-sm-none">
					Little About Us
				</h5>
			</div>
			<p class="text-dark-blue text-justify" style="font-size: large;">
				Annaa Silicon Technology is a complete IT Services company with major
				focus on Retail, religion and Health Verticals. The Company is head quartered in Kumbakonam, India
				and recently expanded its operations in Chennai, India. The Company is mentored by Domain Experts and
				entrepreneurs from Phoenix, USA and UK. The Company has been
				delivering end-to-end software development, quality assurance and Annual maintenance support solutions
				to
				clients ranging from Fortune 1000 companies to startups in all
				stages of funding since 2003.Our mission is to provide high value IT solutions and services to our
				customers
				with distinctive competence and integrity by working together
				for the shared long term objectives.
			</p>
			<div class="col-xs-12 text-right pr-3 d-none d-sm-block">
				<button type="button" class="btn btn-outline btn-read waves-effect p-2" routerLink="/about-us">
					Read More
					<span class="fa fa-arrow-right"></span>
				</button>
			</div>
			<div class="col-xs-12 text-center mb-3 pr-3 d-block d-sm-none">
				<button type="button" class="btn btn-outline btn-read waves-effect p-2" routerLink="/about-us">
					Read More
					<span class="fa fa-arrow-right"></span>
				</button>
			</div>
		</div>
	</div> -->

	<!--	-------	 Our Products	----------	 -->
	<!-- <div class="statistic-section-bg p-2">
		<div class="container-fluid animatable moveUp">
			<div class="container row">
				<div class="border border-bottom-0 border-left-0 border-top-0 p-2 d-none d-sm-block">
					<span class="fa fa-graduation-cap section-icon"></span>
				</div>
				 <h2 class="text-center text-light mb-4 font-weight-bolder text-uppercase p-2">
					Our Achivements
				</h2> 
				<h2 class="text-center text-light mb-4 font-weight-bolder text-uppercase p-2 d-none d-sm-block">
					Our Achivements
				</h2>
				<h5 class="text-center text-light  font-weight-bolder text-uppercase p-2 d-block d-sm-none">
					Our Achivements
				</h5>
			</div>
			<section id="statistic" class="statistic-section one-page-section pb-2">
				<div class="container pb-3">
					<div class="row text-center">
						<div class="col-xs-12 col-md-3">
							<div class="counter">
								<i class="fa fa-coffee fa-2x stats-icon"></i>
								<h2 class="timer count-title count-number">999</h2>
								<div class="stats-line-black"></div>
								<h5 class="stats-text">Coffee Cups</h5>
							</div>
						</div>
						<div class="col-xs-12 col-md-3">
							<div class="counter">
								<i class="fa fa-code fa-2x stats-icon"></i>
								<h2 class="timer count-title count-number">10000
								</h2>
								<div class="stats-line-black"></div>
								<h5 class="stats-text">Line Code</h5>
							</div>
						</div>
						<div class="col-xs-12 col-md-3">
							<div class="counter">
								<i class="fa fa-clock-o fa-2x stats-icon"></i>
								<h2 class="timer count-title count-number">17</h2>
								<div class="stats-line-black"></div>
								<h5 class="stats-text">Years Experience</h5>
							</div>
						</div>
						<div class="col-xs-12 col-md-3">
							<div class="counter">
								<i class="fa fa-laptop fa-2x stats-icon"></i>
								<h2 class="timer count-title count-number">1035</h2>
								<div class="stats-line-black"></div>
								<h5 class="stats-text">Project</h5>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div> -->

	<!--	-------  Our Services	-------	 -->

	<!-- <div class="color p-4 animatable bounceIn">
		<div class="container row">
			<div class="border border-bottom-0 border-left-0 border-top-0 p-2 d-none d-sm-block">
				<span class="fa fa-globe head-icon"></span>
			</div>
			<h2 class="text-center text-light mb-4 font-weight-bolder text-uppercase p-2">
				OUR WEB APPLICATIONS
			</h2>
			<h2 class="text-center text-dark-blue mb-4 font-weight-bolder text-uppercase p-2 d-none d-sm-block">
				OUR WEB APPLICATIONS
			</h2>
			<h5 class="text-center text-dark-blue  font-weight-bolder text-uppercase p-2 d-block d-sm-none">
				OUR WEB APPLICATIONS
			</h5>
		</div>
		<br />
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-12 col-sm-12 col-12">
					<div id="demo" class="carousel slide" data-ride="carousel">
						 Indicators -->
						<!-- <ul class="carousel-indicators">
						<li data-target="#demo" data-slide-to="0" class="active"></li>
						<li data-target="#demo" data-slide-to="1"></li>
						<li data-target="#demo" data-slide-to="2"></li>
						</ul> -->

						<!-- The slideshow -->
						<!-- <div class="carousel-inner">
							<div class="carousel-item active">
								<div class="row justify-content-center">
									<div class="col-md-8 col-sm-12 col-12 text-center">
										<span class="fa fa-shopping-cart app-icon" aria-hidden="true"></span>
									</div>
									<div class="col-md-12 col-sm-12 col-12">
										<div class="app-title text-dark-blue">
											Retail Management
										</div>
										<div class="app-desc text-dark-blue">
											A retail management system (RMS) is a platform that combines several useful
											tools to aid in running a retail store or chain, such as inventory
											management,
											point of sale (POS), and customer relationship management (CRM). ... Some
											platforms will even have marketing and analytics tools to help you improve
											your
											business.
										</div>
										<div class="col-md-4 col-sm-8 col-12 colapp-link">
											Know More
										</div> 
									</div>
								</div>
							</div>
							<div class="carousel-item">
								<div class="row justify-content-center">
									<div class="col-md-8 col-sm-12 col-12 text-center">
										<span class="fa fa-university app-icon" aria-hidden="true"></span>
									</div>
									<div class="col-md-12 col-sm-12 col-12">
										<div class="app-title text-dark-blue">
											School Management
										</div>
										<div class="app-desc text-dark-blue">
											School management software is a tool that is specifically designed to
											streamline
											the paperless administration of schools and educational institutions. It
											consists of various modules that greatly help the teachers and staff in
											maintaining student records, academic history, and other essential student
											information.
										</div>
										<div class="col-md-4 col-sm-8 col-12 colapp-link">
											Know More
										</div> 
									</div>
								</div>
							</div>
							<div class="carousel-item">
								<div class="row justify-content-center">
									<div class="col-md-8 col-sm-12 col-12 text-center">
										<span class="fa fa-medkit app-icon" aria-hidden="true"></span>
									</div>
									<div class="col-md-12 col-sm-12 col-12">
										<div class="app-title text-dark-blue">
											Hospital Management
										</div>
										<div class="app-desc text-dark-blue">
											The hospital management system (HMS) is an integrated software that handles
											different directions of clinic workflows. It manages the smooth healthcare
											performance along with administrative, medical, legal and financial control.
											That is a cornerstone for the successful operation of the healthcare
											facility.
										</div>
										 <div class="col-md-4 col-sm-8 col-12 colapp-link">
											Know More
										</div> 
									</div>
								</div>
							</div>
							<div class="carousel-item">
								<div class="row justify-content-center">
									<div class="col-md-8 col-sm-12 col-12 text-center">
										<span class="fa fa-building app-icon" aria-hidden="true"></span>
									</div>
									<div class="col-md-12 col-sm-12 col-12">
										<div class="app-title text-dark-blue">
											Hotel Management
										</div>
										<div class="app-desc text-dark-blue">
											A hotel management software is a platform with which an independent hotel or
											a
											hotel group can automate all their operations. This software streamlines
											various
											tasks of your hotel such as front desk, billing, revenue management and much
											more.
										</div>
										 <div class="col-md-4 col-sm-8 col-12 colapp-link">
											Know More
										</div> 
									</div>
								</div>
							</div>
							<div class="carousel-item">
								<div class="row justify-content-center">
									<div class="col-md-8 col-sm-12 col-12 text-center">
										<span class="fa fa-hand-o-right app-icon" aria-hidden="true"></span>
									</div>
									<div class="col-md-12 col-sm-12 col-12">
										<div class="app-title text-dark-blue">
											For our more web applicaton and softwares click below
										</div>
										<div class="app-desc text-dark-blue">
											<button class="btn btn-outline btn-read waves-effect p-2" routerLink="/ourproducts">
												Know More
											</button>
										</div>
										<div class="col-md-4 col-sm-8 col-12 colapp-link">
											Know More
										</div> 
									</div>
								</div>
							</div>
						</div>

						Left and right controls 
						<a class="carousel-control-prev text-dark" href="#demo" data-slide="prev">
							<span aria-hidden="true">
								<svg xmlns="http://www.w3.org/2000/svg" fill="darkblue" viewBox="0 0 16 16" width="32" height="32">
									<path fill-rule="evenodd" d="M11.354 3.354a.5.5 0 0 1 0 .707L7.707 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0z"/>
								</svg>
							</span>
						</a>
						<a class="carousel-control-next text-dark" href="#demo" data-slide="next">
							<span aria-hidden="true">
								<svg xmlns="http://www.w3.org/2000/svg" fill="darkblue" viewBox="0 0 16 16" width="32" height="32">
									<path fill-rule="evenodd" d="M4.646 3.354a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L8.293 8 4.646 4.354a.5.5 0 0 1 0-.708z"/>
								</svg>
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
		<br />
	</div> -->
</div>



<!-- <div class="col-12">
	<a href="#" id="scroll" style="display: none;"><span></span></a>
</div> -->


<!--	MOBILE VIEW -->
<div class=" d-block d-sm-none">
	<div class="header-gradient p-2">
		<div class="slideshow-container">
			<div class="slide" *ngFor="let slide of slides; let i = index" [class.active]="i === currentIndex">
			  <img [src]="slide.image" alt="Slide Image" class="slide-image" />
			  <div class="caption">{{ slide.caption }}</div>
			</div>
		  </div>
		<!-- <div class="card product-card ">
			<div class="card-body d-block d-sm-none">
				<h4 class="text-light p-2">
					Annaa Silicon Technology Private Limited <sub> </sub>
					 <sup style="border: 2px solid #fff; border-radius: 50%; padding: 0.5%; margin: 1%;"> 
						<i class="fa fa-registered fa-1x" aria-hidden="true" style="padding: 0.3%; margin: 1%;"></i>
					 </sup> 
				</h4>
				<h6 class="text-light font-italic company">
					Technology Makers Pleasure
				</h6>
			</div>

			<div class="row pb-3 w3-animate-left">
				<div class="col-md-2 col-sm-12 col-xs-8 text-center">
					<img src="./../../assets/img/home/icon/work.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Work Collaboration</h5>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 text-center">
					<img src="./../../assets/img/home/icon/messages.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Bulk SMS Gateway</h5>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 text-center">
					<img src="./../../assets/img/home/icon/barcode.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Barcode Solutions</h5>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 text-center">
					<img src="./../../assets/img/home/icon/website.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Web Application</h5>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 text-center">
					<img src="./../../assets/img/home/icon/mobile.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Mobile Applications</h5>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 text-center">
					<img src="./../../assets/img/home/icon/pay.png" class="rounded pb-2" style="width: 70%;"
						alt="ICON" />
					<h5 class="text-center text-light">Payroll Management</h5>
				</div>
			</div>
		</div> -->
	</div>

	<!--	-------  Our Services	-------	 -->

	<div class="p-4">
		<div class="container-fluid">
			<div class="container row">
				<div class="border border-bottom-0 border-left-0 border-top-0 p-2 d-none d-sm-block">
					<span class="fa fa-cogs service-icon" aria-hidden="true"></span>
				</div>
				<h2 class="text-center text-dark mb-4 font-weight-bolder text-uppercase p-2 d-none d-sm-block">
					Our Services
				</h2>
				<h5 class="text-center text-dark mb-4 font-weight-bolder text-uppercase p-2 d-block d-sm-none">
					Our Services
				</h5>
			</div>
			<br />
			<div class="row">
				<div class="col-md-5 col-sm-12 col-xs-12  bounceIn">
					<div class="card service-card border-0 p-4 ">
						<div class="text-center">
							<span class="fa fa-gear service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								multi brand screw air compressor service
							</h6>
							<p class="text-justify text-muted" style="color: black;">
								Regular Inspections: Conduct routine checks to identify potential issues early..
							</p><br />
							<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/verticals">
								Show More
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-5 col-sm-12 col-xs-12 bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-bolt service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								Multi brand piston compressor service
							</h6>
							<p class="text-justify text-muted">
								Expert maintenance and repair for all multi-brand piston compressors, ensuring optimal performance and reliability..
							</p><br>
							<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/verticals">
								Show More
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12 animatable bounceInLeft">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-hammer service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								Multi brand air dryer service
							</h6>
							<p class="text-justify text-muted">
								Comprehensive servicing and repairs for all multi-brand air dryers to maintain efficient, moisture-free air supply.
							</p><br>
							<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/verticals">
								Show More
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-industry service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								multi brand water chiller services 
							</h6>
							<p class="text-justify text-muted">
								Efficient servicing and repair solutions for all multi-brand water chillers, ensuring optimal cooling performance and energy savings.
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/verticals">
										Show More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceInRight">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-plug service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								air pipe line works 
							</h6>
							<p class="text-justify text-muted">
								Expert installation, maintenance, and repair of air pipelines to ensure efficient and safe air distribution across your facility.
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/verticals">
										Show More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-fire-extinguisher service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								panel air cooler services
							</h6>
							<p class="text-justify text-muted">
								Comprehensive servicing and maintenance of panel air coolers to ensure optimal cooling performance and energy efficiency.
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/verticals">
										Show More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<br />
	</div>




	


	<div class="p-4">
		<div class="container-fluid">
			<div class="container row">
				<div class="border border-bottom-0 border-left-0 border-top-0 p-2 d-none d-sm-block">
					<span class="fa fa-shopping-basket"></span>
				</div>
				<h2 class="text-center text-dark mb-4 font-weight-bolder text-uppercase p-2 d-none d-sm-block">
					Our Products
				</h2>
				<h5 class="text-center text-dark mb-4 font-weight-bolder text-uppercase p-2 d-block d-sm-none">
					Our Products
				</h5>
			</div>
			<br />
			<div class="row">
				<div class="col-md-5 col-sm-12 col-xs-12  bounceIn">
					<div class="card service-card border-0 p-4 ">
						<div class="text-center">
							<span class="fa fa-screwdriver service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								SCREW AIR COMPRESSOR 
							</h6>
							<p class="text-justify text-muted">
								A screw air compressor is a reliable and efficient rotary device designed to compress air for industrial applications.
							</p><br />
							<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/ourproducts">
								Know More
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-5 col-sm-12 col-xs-12 bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-compress service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								PISTON AIR COMPRESSOR
							</h6>
							<p class="text-justify text-muted">
								A piston air compressor is a robust and versatile machine that uses reciprocating motion to compress air.
							</p><br>
							<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/ourproducts">
								Know More
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12 animatable bounceInLeft">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-hand-paper-o service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								AIR DRYER
							</h6>
							<p class="text-justify text-muted">
								An air dryer removes moisture from compressed air, ensuring dry and clean air for improved system performance and protection against corrosion.
							</p><br>
							<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/ourproducts">
								Know More
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-wrench service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								AIR RECEIVER TANK
							</h6>
							<p class="text-justify text-muted">
								An air receiver tank stores compressed air, stabilizes pressure, and enhances system efficiency by reducing load fluctuations on the compressor.
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/ourproducts">
										Know More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceInRight">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-users service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								WATER CHILLER
							</h6>
							<p class="text-justify text-muted">
								A water chiller is a refrigeration system that removes heat from water, providing cooled water for industrial processes or air conditioning applications.
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/ourproducts">
										Know More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-fire service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								OIL CHILLER
							</h6>
							<p class="text-justify text-muted">
								An oil chiller is a cooling device that regulates the temperature of oils and lubricants in machinery, ensuring optimal performance and preventing overheating.
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/ourproducts">
										Know More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12  animatable bounceIn">
					<div class="card service-card border-0 p-4">
						<div class="text-center">
							<span class="fa fa-asterisk service-icon" aria-hidden="true"></span>
							<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
								AIR ACCESSORIES
							</h6>
							<p class="text-justify text-muted">
								An oil chiller is a cooling device that regulates the temperature of oils and lubricants in machinery.
							</p><br>
							<div class="row justify-content-center">
								<div class="col-md-10 col-sm-12 col-12 text-center">
									<button class="btn service-btn text-white mt-3 pt-2 pb-2" routerLink="/ourproducts">
										Know More
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<br />
	</div>

	<!--	------	 About US	----------	 -->
	<!-- <div class="row col  text-center">
		<div class="col-md-6 col-sm-12 col-xs-12"
			style="padding-left: 0px; padding-right: 0px; margin-left: 0px; margin-right: 0px;">
			<img src="./../../assets/img/home/rb_1592.png" style="width: 100%;" />
		</div>

		<div class="color col-md-6 col-sm-12 col-xs-12">
			<div class="row text-right">
				<div class="border border-bottom-0 border-left-0 border-top-0 p-2  d-none d-sm-block">
					<span class="fa fa-user head-icon"></span>
				</div>
				<h2 class="text-center text-dark-blue mb-4 font-weight-bolder text-uppercase p-2 d-none d-sm-block">
					Little About Us
				</h2>
				<h5 class="text-center text-dark-blue  font-weight-bolder text-uppercase p-2 d-block d-sm-none">
					Little About Us
				</h5>
			</div>
			<p class="text-dark-blue text-justify">
				Annaa Silicon Technology is a complete IT Services company with major
				focus on Retail, religion and Health Verticals. The Company is head quartered in Kumbakonam, India
				and recently expanded its operations in Chennai, India. The Company is mentored by Domain Experts and
				entrepreneurs from Phoenix, USA and London UK.The Company has been
				delivering end-to-end software development, quality assurance and Annual maintenance support solutions
				to
				clients ranging from Fortune 1000 companies to startups in all
				stages of funding since 2003.Our mission is to provide high value IT solutions and services to our
				customers
				with distinctive competence and integrity by working together
				for the shared long term objectives.
			</p>
			<div class="col-xs-12 text-center mb-3 pr-3 d-block d-sm-none">
				<button type="button" class="btn btn-read btn-outline-primary waves-effect p-2" routerLink="/about-us">
					Read More
					<span class="fa fa-arrow-right"></span>
				</button>
			</div>
		</div>
	</div> -->

	<!--	-------	 Our Products	----------	 -->
	<!-- <div class="statistic-section-bg p-2">
		<div class="container-fluid">
			<div class="container row">
				<div class="border border-bottom-0 border-left-0 border-top-0 p-2 d-none d-sm-block">
					<span class="fa fa-trophy section-icon"></span>
				</div>
				<!-- <h2 class="text-center text-light mb-4 font-weight-bolder text-uppercase p-2">
					Our Achivements
				</h2> 
				<h2 class="text-center text-light mb-4 font-weight-bolder text-uppercase p-2 d-none d-sm-block">
					Our Achivements
				</h2>
				<h5 class="text-center text-light  font-weight-bolder text-uppercase p-2 d-block d-sm-none">
					Our Achivements
				</h5>
			</div>
			<section id="statistic" class="statistic-section one-page-section pb-2">
				<div class="container pb-3">
					<div class="row text-center">
						<div class="col-xs-12 col-md-3">
							<div class="counter">
								<i class="fa fa-coffee fa-2x stats-icon"></i>
								<h2 class="timer count-title count-number">999</h2>
								<div class="stats-line-black"></div>
								<h5 class="stats-text">Coffee Cups</h5>
							</div>
						</div>
						<div class="col-xs-12 col-md-3">
							<div class="counter">
								<i class="fa fa-code fa-2x stats-icon"></i>
								<h2 class="timer count-title count-number">10000
								</h2>
								<div class="stats-line-black"></div>
								<h5 class="stats-text">Line Code</h5>
							</div>
						</div>
						<div class="col-xs-12 col-md-3">
							<div class="counter">
								<i class="fa fa-clock-o fa-2x stats-icon"></i>
								<h2 class="timer count-title count-number">17</h2>
								<div class="stats-line-black"></div>
								<h5 class="stats-text">Years Experience</h5>
							</div>
						</div>
						<div class="col-xs-12 col-md-3">
							<div class="counter">
								<i class="fa fa-laptop fa-2x stats-icon"></i>
								<h2 class="timer count-title count-number">1035</h2>
								<div class="stats-line-black"></div>
								<h5 class="stats-text">Project</h5>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div> -->

	<!--	-------  Our Services	-------	 -->

	<!-- <div class="color p-4">
		<div class="container-fluid row">
			<div class="border border-bottom-0 border-left-0 border-top-0 p-2 d-none d-sm-block">
				<span class="fa fa-dashboard head-icon"></span>
			</div>
			<h2 class="text-center text-light mb-4 font-weight-bolder text-uppercase p-2">
				OUR WEB APPLICATIONS
			</h2> 
			<h2 class="text-center text-dark-blue mb-4 font-weight-bolder text-uppercase p-2 d-none d-sm-block">
				OUR WEB APPLICATIONS
			</h2>
			<h5 class="text-center text-dark-blue font-weight-bolder text-uppercase p-2 d-block d-sm-none">
				OUR WEB APPLICATIONS
			</h5>
		</div>
		<br />
		<div class="container-fluid">
			<div class="row justify-content-center">
				<div class="col-md-12 col-sm-12 col-12">
					<div id="demo1" class="carousel slide" data-ride="carousel1">
						Indicators -->
						<!-- <ul class="carousel-indicators">
						<li data-target="#demo" data-slide-to="0" class="active"></li>
						<li data-target="#demo" data-slide-to="1"></li>
						<li data-target="#demo" data-slide-to="2"></li>
						</ul> 

						 The slideshow 
						<div class="carousel-inner">
							<div class="carousel-item active">
								<div class="row justify-content-center">
									<div class="col-md-8 col-sm-12 col-12 text-center">
										<span class="fa fa-shopping-cart app-icon" aria-hidden="true"></span>
									</div>
									<div class="col-md-12 col-sm-12 col-12">
										<div class="app-title text-dark-blue">
											Retail Management
										</div>
										<div class="app-desc text-light">
											A retail management system (RMS) is a platform that combines several useful
											tools to aid in running a retail store or chain, such as inventory management,
											point of sale (POS), and customer relationship management (CRM). ... Some
											platforms will even have marketing and analytics tools to help you improve your
											business.
										</div> -->
										<!-- <div class="col-md-4 col-sm-8 col-12 colapp-link">
											Know More
										</div> 
									</div>
								</div>
							</div>
							<div class="carousel-item">
								<div class="row justify-content-center">
									<div class="col-md-8 col-sm-12 col-12 text-center">
										<span class="fa fa-university app-icon" aria-hidden="true"></span>
									</div>
									<div class="col-md-12 col-sm-12 col-12">
										<div class="app-title text-dark-blue">
											School Management
										</div>
										<div class="app-desc text-light">
											School management software is a tool that is specifically designed to streamline
											the paperless administration of schools and educational institutions. It
											consists of various modules that greatly help the teachers and staff in
											maintaining student records, academic history, and other essential student
											information.
										</div> -->
										<!-- <div class="col-md-4 col-sm-8 col-12 colapp-link">
											Know More
										</div> 
									</div>
								</div>
							</div>
							<div class="carousel-item">
								<div class="row justify-content-center">
									<div class="col-md-8 col-sm-12 col-12 text-center">
										<span class="fa fa-medkit app-icon" aria-hidden="true"></span>
									</div>
									<div class="col-md-12 col-sm-12 col-12">
										<div class="app-title text-dark-blue">
											Hospital Management
										</div>
										 <div class="app-desc text-light">
											The hospital management system (HMS) is an integrated software that handles
											different directions of clinic workflows. It manages the smooth healthcare
											performance along with administrative, medical, legal and financial control.
											That is a cornerstone for the successful operation of the healthcare facility.
										</div> -->
										<!-- <div class="col-md-4 col-sm-8 col-12 colapp-link">
											Know More
										</div> -
									</div>
								</div>
							</div>
							<div class="carousel-item">
								<div class="row justify-content-center">
									<div class="col-md-8 col-sm-12 col-12 text-center">
										<span class="fa fa-building app-icon" aria-hidden="true"></span>
									</div>
									<div class="col-md-12 col-sm-12 col-12">
										<div class="app-title text-dark-blue">
											Hotel Management
										</div>
										 <div class="app-desc text-light">
											A hotel management software is a platform with which an independent hotel or a
											hotel group can automate all their operations. This software streamlines various
											tasks of your hotel such as front desk, billing, revenue management and much
											more.
										</div> -->
										<!-- <div class="col-md-4 col-sm-8 col-12 colapp-link">
											Know More
										</div> 
									</div>
								</div>
							</div>
							<div class="carousel-item">
								<div class="row justify-content-center">
									<div class="col-md-8 col-sm-12 col-12 text-center">
										<span class="fa fa-hand-o-right app-icon" aria-hidden="true"></span>
									</div>
									<div class="col-md-12 col-sm-12 col-12">
										<div class="app-title text-dark-blue">
											For our more web applicaton and softwares click below
										</div>
										<div class="app-desc text-dark-blue">
											<button class="btn btn-outline btn-read waves-effect p-2" routerLink="/ourproducts">
												Know More
											</button>
										</div>
										<div class="col-md-4 col-sm-8 col-12 colapp-link">
											Know More
										</div> 
									</div>
								</div>
							</div>
						</div>

						Left and right controls 
						<a class="carousel-control-prev text-dark" href="#demo1" data-slide="prev">
							<span aria-hidden="true">
								<svg xmlns="http://www.w3.org/2000/svg" fill="darkblue" viewBox="0 0 16 16" width="32" height="32">
									<path fill-rule="evenodd" d="M11.354 3.354a.5.5 0 0 1 0 .707L7.707 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0z"/>
								</svg>
							</span>
						</a>
						<a class="carousel-control-next text-dark" href="#demo1" data-slide="next">
							<span aria-hidden="true">
								<svg xmlns="http://www.w3.org/2000/svg" fill="darkblue" viewBox="0 0 16 16" width="32" height="32">
									<path fill-rule="evenodd" d="M4.646 3.354a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L8.293 8 4.646 4.354a.5.5 0 0 1 0-.708z"/>
								</svg>
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
		<br />
	</div> -->
</div>

<!-- 	---------	AUTO MODEL	----------	  -->
<!-- <div class="modal fade" id="myModal">
	<div class="modal-dialog modal-lg">
		<div class="modal-content"> -->
			<!-- Modal body  -->
			<!-- <div class="modal-body">
				<button type="button" class="close" data-dismiss="modal">&times;</button>
				<div class="modal-body-content">
					<div class="row">
						<div class="col-md-4 col-sm-12 col-xs-12">
							<div class="profile-sidebar text-center">
								<img src="./../../assets/img/home/md.png" class="rounded-circle modal-img" alt="" />
							</div>
						</div>
						<div class="col-md-8 col-sm-12 col-xs-12 text-center">
							<div class="pt-5">
								<h2 class="font-weight-bolder">K.Gnanaguru</h2>
								<h3 class="font-weight-normal">Managing Director</h3>
								<h5 style="color: black;">
									<i class="fa fa-phone" aria-hidden="true">&nbsp;95146 87687, 9344303015</i>
								</h5>
								<h5 style="color: black;">
									<i class="fa fa-phone" aria-hidden="true">&nbsp;9843683020, 95433 61507</i>
								</h5>
							</div>
						</div>
					</div>
				</div> -->
				<!---------------------------------------	XS_VIEW		--------------------------->
			<!-- </div>
		</div>
	</div>
</div> -->